module.exports = __webpack_public_path__ + "img/symbol_4.c8062f7e.png";